import { LoanProductType } from "../../../hooks/api/types";
import {
  AdvanceCashflowLoanCalculator,
  BuyNowPayLaterLoanCalculator,
  PayablesFinanceLoanCalculator,
  PayablesLOCLoanCalculator,
  POSRevenueBasedFinanceLoanCalculator,
  ReceivablesFinanceLoanCalculator,
  ReceivablesLOCLoanCalculator,
  RevenueBasedFinanceLoanCalculator,
} from ".";

type Props = {
  product: LoanProductType;
  editMode?: boolean;
  tags?: string[];
  message?: string;
  handleSubmit?: () => void;
  handleCancel?: () => void;
  render?: (calculator: React.ReactNode) => React.ReactNode; // pass this argument if you want to render the calculator in a different way
};

const LoanCalculatorFactory: React.FC<Props> = ({
  product,
  render,
  ...rest
}) => {
  let component: React.ReactNode = null;

  switch (product) {
    case LoanProductType.FIXED_TERM:
      component = <AdvanceCashflowLoanCalculator {...rest} />;
      break;
    case LoanProductType.INVOICE_DISCOUNTING:
      component = <ReceivablesFinanceLoanCalculator {...rest} />;
      break;
    case LoanProductType.PAYABLE_FINANCING:
      component = <PayablesFinanceLoanCalculator {...rest} />;
      break;
    case LoanProductType.REVENUE_BASED_FINANCING:
      component = <RevenueBasedFinanceLoanCalculator {...rest} />;
      break;
    case LoanProductType.BNPL:
      component = <BuyNowPayLaterLoanCalculator {...rest} />;
      break;
    case LoanProductType.POS_REVENUE_BASED_FINANCING:
      component = <POSRevenueBasedFinanceLoanCalculator {...rest} />;
      break;
    case LoanProductType.LOC_INVOICE_DISCOUNTING:
      component = <ReceivablesLOCLoanCalculator {...rest} />;
      break;
    case LoanProductType.LOC_PAYABLE_FINANCING:
      component = <PayablesLOCLoanCalculator {...rest} />;
      break;
    default:
      return null;
  }

  return render ? <>{render(component)}</> : component;
};

export default LoanCalculatorFactory;
